import React from 'react';
import { Outlet } from 'react-router-dom';
import AnonymousModeBanner from '../common/AnonymousModeBanner';
import { ProfileBar } from '../profile/ProfileBar';
import Navigation from '../navigation/Navigation';

const PublicLayout: React.FC = () => {
  return (
    <>
      <ProfileBar />
      <AnonymousModeBanner />
      <Navigation />
      <Outlet />
    </>
  );
};

export default PublicLayout;
